import { lightBlue } from '../palette';
import { style } from '../layer.css';

export const fileInput = style({
  selectors: {
    '&:has(input:focus-visible)': {
      outline: `2px solid ${lightBlue[500]}`,
      outlineOffset: '-1px',
    },
  },
});
